/*
 * Tasi redesign — product page behaviour (sections/tasi-product-main.liquid,
 * sections/tasi-product-recommendations.liquid).
 * - gallery: mobile swipe dots, lighting stage (thumbs, Stinsă/Aprinsă toggle, swipe)
 * - lightbox "Mărește" with keyboard navigation
 * - variant picker, quantity stepper, add to cart via TasiCart.add (shared cart contract)
 * - mobile sticky add-to-cart bar
 * - product recommendations (Product Recommendations API + server-rendered fallback)
 */
(function () {
	'use strict';

	function T(k, d) { var i = (window.Tasi && window.Tasi.i18n) || {}; return i[k] != null ? i[k] : d; }

	const formatMoney = (cents) => {
		const format = (window.Tasi && window.Tasi.moneyFormat) || '{{amount_with_comma_separator}} lei';
		const value = Number(cents) / 100;
		const group = (n, sep) => n.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
		const fmt = (decimals, thousands, decimal) => {
			const fixed = value.toFixed(decimals);
			let [int, frac] = fixed.split('.');
			int = group(int, thousands);
			// money_without_trailing_zeros: drop ",00"
			if (!frac || /^0+$/.test(frac)) return int;
			return int + decimal + frac;
		};
		return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
			switch (key) {
				case 'amount': return fmt(2, ',', '.');
				case 'amount_no_decimals': return fmt(0, ',', '.');
				case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
				case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
				case 'amount_with_comma_separator':
				default: return fmt(2, '.', ',');
			}
		}).replace(/<[^>]*>/g, '');
	};

	function initGallery(root) {
		const gal = root.querySelector('[data-tp-gallery]');
		if (!gal) return { show: () => {} };

		// Mobile swipe dots (furniture grid becomes a scroll-snap track under 768px)
		const track = gal.querySelector('[data-tp-track]');
		const dots = gal.querySelectorAll('.tp-dot');
		if (track && dots.length) {
			let ticking = false;
			track.addEventListener('scroll', () => {
				if (ticking) return;
				ticking = true;
				requestAnimationFrame(() => {
					const i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
					dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
					ticking = false;
				});
			}, { passive: true });
		}

		// Lighting stage
		const stage = gal.querySelector('[data-tp-stage]');
		const slides = gal.querySelectorAll('[data-tp-slide]');
		const thumbs = gal.querySelectorAll('[data-tp-thumb]');
		const toggles = gal.querySelectorAll('[data-tp-lit]');
		const litPos = gal.hasAttribute('data-lit') ? Number(gal.dataset.lit) : -1;
		let current = 0;
		const show = (pos) => {
			if (!stage) return;
			const n = slides.length;
			current = (pos + n) % n;
			slides.forEach((s) => {
				const on = Number(s.dataset.tpSlide) === current;
				s.hidden = !on;
				s.classList.toggle('is-active', on);
			});
			thumbs.forEach((t) => t.setAttribute('aria-pressed', String(Number(t.dataset.tpThumb) === current)));
			toggles.forEach((b) => {
				const lit = current === litPos;
				b.setAttribute('aria-pressed', String(b.dataset.tpLit === 'on' ? lit : !lit));
			});
		};
		thumbs.forEach((t) => t.addEventListener('click', () => show(Number(t.dataset.tpThumb))));
		toggles.forEach((b) => b.addEventListener('click', () => show(b.dataset.tpLit === 'on' ? litPos : 0)));
		if (stage && slides.length > 1) {
			let x0 = null;
			let moved = false;
			stage.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; moved = false; }, { passive: true });
			stage.addEventListener('touchmove', (e) => { if (x0 !== null && Math.abs(e.touches[0].clientX - x0) > 10) moved = true; }, { passive: true });
			stage.addEventListener('touchend', (e) => {
				if (x0 === null) return;
				const dx = e.changedTouches[0].clientX - x0;
				x0 = null;
				if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
			});
			stage.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
		}
		return { show, get current() { return current; } };
	}

	function initLightbox(root) {
		const lb = root.querySelector('[data-tp-lb]');
		if (!lb || typeof lb.showModal !== 'function') return;
		const slides = lb.querySelectorAll('[data-tp-lb-slide]');
		const count = lb.querySelector('[data-tp-lb-count]');
		let idx = 0;
		let opener = null;
		const go = (i) => {
			idx = (i + slides.length) % slides.length;
			slides.forEach((s, n) => {
				s.hidden = n !== idx;
				// Load the current image and its neighbours right away (lazy images inside a closed dialog).
				const d = Math.abs(n - idx);
				if (d <= 1 || d === slides.length - 1) { const img = s.querySelector('img'); if (img) img.loading = 'eager'; }
			});
			if (count) count.textContent = (idx + 1) + ' / ' + slides.length;
		};
		root.addEventListener('click', (e) => {
			const btn = e.target.closest('[data-tp-zoom]');
			if (!btn || !root.contains(btn)) return;
			opener = btn;
			go(Number(btn.dataset.tpZoom) || 0);
			lb.showModal();
			document.body.classList.add('t-lock');
			lb.querySelector('[data-tp-lb-close]').focus();
		});
		lb.addEventListener('click', (e) => {
			const step = e.target.closest('[data-tp-lb-step]');
			if (step) { go(idx + Number(step.dataset.tpLbStep)); return; }
			if (e.target.closest('[data-tp-lb-close]')) lb.close();
		});
		lb.addEventListener('keydown', (e) => {
			if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
			if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
		});
		let x0 = null;
		lb.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
		lb.addEventListener('touchend', (e) => {
			if (x0 === null) return;
			const dx = e.changedTouches[0].clientX - x0;
			x0 = null;
			if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
		});
		lb.addEventListener('close', () => {
			document.body.classList.remove('t-lock');
			if (opener) opener.focus();
		});
	}

	function initForm(root, gallery) {
		const form = root.querySelector('[data-tp-form]');
		if (!form) return;
		const idInput = form.querySelector('[data-tp-variant-id]');
		const qty = form.querySelector('[data-tp-qty-input]');
		const addBtn = form.querySelector('[data-tp-add]');
		const addLabel = form.querySelector('[data-tp-add-label]');
		const error = form.querySelector('[data-tp-error]');
		const sticky = root.querySelector('[data-tp-sticky]');
		const stickyAdd = root.querySelector('[data-tp-sticky-add]');
		const labelAdd = addLabel ? addLabel.textContent.trim() : T('product.add_to_cart', 'Adaugă în coș');
		const soldOutText = T('product.sold_out', 'Stoc epuizat');
		let available = !addBtn.disabled;

		// Quantity stepper
		form.querySelectorAll('[data-tp-qty]').forEach((b) => b.addEventListener('click', () => {
			const v = Math.max(1, Math.min(99, (parseInt(qty.value, 10) || 1) + Number(b.dataset.tpQty)));
			qty.value = v;
		}));
		qty.addEventListener('change', () => { qty.value = Math.max(1, Math.min(99, parseInt(qty.value, 10) || 1)); });

		const setAvailability = (ok) => {
			available = ok;
			addBtn.disabled = !ok;
			if (stickyAdd) { stickyAdd.disabled = !ok; stickyAdd.textContent = ok ? labelAdd : soldOutText; }
			if (addLabel) addLabel.textContent = ok ? labelAdd : soldOutText;
		};

		// "În stoc" / "La comandă" line + the Livrare line property (only sent for 'order')
		const stock = root.querySelector('[data-tp-stock]');
		const stockProp = form.querySelector('[data-tp-stock-prop]');
		const setStock = (state) => {
			if (stock) {
				const label = stock.querySelector('[data-tp-stock-label]');
				stock.classList.remove('tp-stock--in', 'tp-stock--order');
				if (state) stock.classList.add('tp-stock--' + state);
				if (label) label.textContent = state === 'in' ? stock.dataset.in : state === 'order' ? stock.dataset.order : '';
				stock.hidden = !state;
			}
			if (stockProp) stockProp.disabled = state !== 'order';
		};

		// Variant picker (only rendered when the product has real variants)
		const variantsEl = form.querySelector('[data-tp-variants]');
		if (variantsEl) {
			let variants = [];
			try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }
			const selects = form.querySelectorAll('[data-tp-option]');
			const onChange = () => {
				const chosen = Array.from(selects).map((s) => s.value);
				const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
				if (!v) { setAvailability(false); return; }
				idInput.value = v.id;
				setAvailability(v.available);
				root.querySelectorAll('[data-tp-price]').forEach((el) => { el.textContent = formatMoney(v.price); });
				const onSale = v.compare > v.price;
				root.querySelectorAll('[data-tp-compare]').forEach((el) => { el.hidden = !onSale; el.textContent = onSale ? formatMoney(v.compare) : ''; });
				const save = root.querySelector('[data-tp-save]');
				if (save) {
					save.classList.toggle('tp-save--plain', !onSale);
					save.textContent = onSale ? T('product.you_save', 'Economisești {amount}').replace('{amount}', formatMoney(v.compare - v.price)) + ' · ' + T('product.vat_included', 'TVA inclus') : T('product.vat_included', 'TVA inclus');
				}
				const sku = root.querySelector('[data-tp-sku]');
				if (sku && v.sku) sku.textContent = v.sku;
				setStock(v.stock || '');
				const url = new URL(window.location.href);
				url.searchParams.set('variant', v.id);
				window.history.replaceState({}, '', url.toString());
			};
			selects.forEach((s) => s.addEventListener('change', onChange));
		}

		// Add to cart via the shared cart contract
		const submit = () => {
			if (!available || addBtn.getAttribute('aria-busy') === 'true') return;
			if (!window.TasiCart) { form.submit(); return; }
			error.hidden = true;
			addBtn.setAttribute('aria-busy', 'true');
			if (addLabel) addLabel.textContent = T('product.adding', 'Se adaugă…');
			if (stickyAdd) stickyAdd.disabled = true;
			const props = {};
			form.querySelectorAll('input[name^="properties["]:not([disabled])').forEach((i) => { props[i.name.slice(11, -1)] = i.value; });
			window.TasiCart.add({ id: Number(idInput.value), quantity: parseInt(qty.value, 10) || 1, properties: props })
				.then(() => {
					if (addLabel) addLabel.textContent = T('product.added', 'Adăugat în coș');
					setTimeout(() => { if (addLabel && available) addLabel.textContent = labelAdd; }, 2000);
				})
				.catch((e) => {
					const msg = (e && (e.description || e.message)) || T('product.add_error_retry', 'Produsul nu a putut fi adăugat în coș. Încearcă din nou.');
					error.textContent = typeof msg === 'string' ? msg : T('product.add_error', 'Produsul nu a putut fi adăugat în coș.');
					error.hidden = false;
					if (addLabel) addLabel.textContent = labelAdd;
					if (e && e.status === 422 && /stoc|stock|sold out|epuizat/i.test(String(e.description || ''))) setAvailability(false);
				})
				.finally(() => {
					addBtn.removeAttribute('aria-busy');
					if (stickyAdd) stickyAdd.disabled = !available;
				});
		};
		form.addEventListener('submit', (e) => { e.preventDefault(); submit(); });
		if (stickyAdd) stickyAdd.addEventListener('click', submit);

		// Sticky bar: visible once the main button has scrolled out of view above the viewport.
		// (A scroll listener, not IntersectionObserver: a fast jump from "below" to "above" never
		// crosses the intersecting state, so the observer would not fire.)
		if (sticky) {
			let ticking = false;
			let shown = false;
			const update = () => {
				ticking = false;
				const show = addBtn.getBoundingClientRect().bottom < 0;
				if (show === shown) return;
				shown = show;
				sticky.classList.toggle('is-visible', show);
				sticky.setAttribute('aria-hidden', String(!show));
				if (show) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
			};
			window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
			update();
		}
	}

	/* Colour-aware recommendations. Colours = this product's own colours (metafield specs.culori), narrowed to
	   the "Culoare" filter the shopper used when they overlap (tasi-collection.js, localStorage 'tasi:culori').
	   Shows products of those colours from the same category (sections/tasi-rec-culoare.liquid rendered on
	   /collections/<handle>?filter.p.m.specs.culori=…) plus products in matching colours (COLOUR_MATCH),
	   e.g. auriu → șampanie, crem, alb, roșu, burgund. Resolves to a grid, or null with fewer than 2 matches. */
	const COLOUR_MATCH = {
		'Auriu': ['Șampanie', 'Crem', 'Bej', 'Alb', 'Auriu rose', 'Roșu', 'Burgund'],
		'Auriu rose': ['Roz', 'Șampanie', 'Crem', 'Alb', 'Auriu'],
		'Șampanie': ['Auriu', 'Crem', 'Bej', 'Alb', 'Auriu rose'],
		'Argintiu': ['Alb', 'Transparent', 'Gri', 'Albastru', 'Turcoaz'],
		'Alb': ['Argintiu', 'Crem', 'Transparent', 'Auriu', 'Albastru'],
		'Crem': ['Bej', 'Alb', 'Auriu', 'Șampanie', 'Maro'],
		'Bej': ['Crem', 'Maro', 'Auriu', 'Șampanie', 'Alb'],
		'Roșu': ['Burgund', 'Auriu', 'Alb', 'Verde'],
		'Burgund': ['Roșu', 'Auriu', 'Roz', 'Șampanie'],
		'Roz': ['Auriu rose', 'Alb', 'Mov', 'Burgund', 'Argintiu'],
		'Mov': ['Roz', 'Argintiu', 'Albastru'],
		'Albastru': ['Argintiu', 'Alb', 'Turcoaz', 'Transparent'],
		'Turcoaz': ['Albastru', 'Argintiu', 'Alb'],
		'Verde': ['Roșu', 'Auriu', 'Alb', 'Maro'],
		'Maro': ['Bej', 'Crem', 'Verde', 'Auriu', 'Cupru'],
		'Cupru': ['Maro', 'Auriu', 'Bej', 'Portocaliu'],
		'Portocaliu': ['Cupru', 'Maro', 'Auriu'],
		'Galben': ['Auriu', 'Alb', 'Verde'],
		'Negru': ['Auriu', 'Argintiu', 'Alb'],
		'Gri': ['Argintiu', 'Alb', 'Negru'],
		'Transparent': ['Argintiu', 'Alb', 'Auriu']
	};
	function colourPref() {
		try {
			const p = JSON.parse(localStorage.getItem('tasi:culori') || 'null');
			if (p && Array.isArray(p.c) && p.c.length && Date.now() - p.t < 2 * 864e5) return p;
		} catch (e) {}
		return null;
	}
	// Display name of a colour value (values stay Romanian; only the shown word is translated).
	const colourName = (c) => T('product.colour_' + c.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, '_'), c);
	const lower = (cs) => cs.map((x) => colourName(x).toLowerCase());
	function colourList(colours) {
		const c = lower(colours);
		return c.length > 1 ? c.slice(0, -1).join(', ') + ' ' + T('product.and', 'și') + ' ' + c[c.length - 1] : c[0];
	}
	const cardColours = (el) => (el.dataset.colours || '').split('|').filter(Boolean);
	// Products only in the wanted colours first, then those whose main colour is wanted, then mixed;
	// with `order` (COLOUR_MATCH list) the nearer matching colour wins (auriu → șampanie before roșu).
	function ranked(els, wanted, order) {
		return els
			.map((el, i) => {
				const cs = cardColours(el);
				const r = cs.length && cs.every((c) => wanted.includes(c)) ? 0 : cs.length && wanted.includes(cs[0]) ? 1 : 2;
				const o = order ? Math.min(...cs.map((c) => (order.includes(c) ? order.indexOf(c) : 99)), 99) : 0;
				return { el, i, r, o };
			})
			.sort((a, b) => a.r - b.r || a.o - b.o || a.i - b.i)
			.map((x) => x.el);
	}

	/* Recommendations rail: at least REC_TARGET products.
	   1. Colours = this product's colours (specs.culori), narrowed to the shopper's "Culoare" filter when they
	      overlap; same-colour products (~3/4) + matching colours (COLOUR_MATCH, ~1/4) from the same category,
	      via sections/tasi-rec-culoare.liquid on /collections/<handle>?filter.p.m.specs.culori=….
	   2. No colours: Product Recommendations API (complementary/related) + the server-rendered fallback.
	   3. Top-up: best sellers of the same category (colour-harmony first when there are colours). */
	const REC_TARGET = 20;
	async function loadRail(sec, apiItems) {
		const d = sec.dataset;
		const pref = colourPref();
		const own = (d.colourOwn || '').split('|').filter((c) => c && c !== 'Multicolor');
		const picked = pref ? own.filter((c) => pref.c.includes(c)) : [];
		const chosen = picked.length ? picked : own.length ? own : pref ? pref.c : [];
		const matches = [];
		chosen.forEach((c) => (COLOUR_MATCH[c] || []).forEach((m) => { if (!chosen.includes(m) && !matches.includes(m)) matches.push(m); }));
		const harmony = chosen.concat(matches);

		const sources = [];
		if (pref && pref.coll && (d.colourColls || '').includes('|' + pref.coll + '|')) sources.push(pref.coll);
		[d.colourLeaf, d.colourDept].forEach((h) => { if (h && !sources.includes(h)) sources.push(h); });
		if (!sources.length && pref && pref.coll && chosen.length) sources.push(pref.coll);

		const fetchCards = async (handle, colours) => {
			const q = new URLSearchParams({ section_id: d.colourSection, sort_by: 'best-selling', 'filter.v.availability': '1' });
			colours.forEach((c) => q.append('filter.p.m.specs.culori', c));
			try {
				const res = await fetch(d.colourUrl + encodeURIComponent(handle) + '?' + q.toString(), { credentials: 'same-origin' });
				if (!res.ok) return [];
				const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
				return Array.from(doc.querySelectorAll('[data-tp-rec-grid] > [data-handle]'));
			} catch (e) { return []; }
		};
		const seen = new Set([d.productHandle]);
		const handleOf = (el) => el.dataset.handle || ((el.querySelector('a[href*="/products/"]') || {}).pathname || '').split('/products/')[1];
		const take = (els, into, max) => els.forEach((el) => {
			const h = handleOf(el);
			if (into.length < max && h && !seen.has(h)) { seen.add(h); into.push(el); }
		});

		let items = [];
		let nSame = 0;
		let nNear = 0;
		if (chosen.length && d.colourSection) {
			const same = [];
			const near = [];
			for (const handle of sources) {
				if (same.length >= REC_TARGET) break;
				take(ranked(await fetchCards(handle, chosen), chosen), same, REC_TARGET);
			}
			if (matches.length) {
				for (const handle of sources) {
					if (near.length >= REC_TARGET) break;
					take(ranked(await fetchCards(handle, matches), harmony, matches), near, REC_TARGET);
				}
			}
			nNear = Math.min(near.length, Math.max(REC_TARGET - same.length, Math.floor(REC_TARGET / 4)));
			nSame = Math.min(same.length, REC_TARGET - nNear);
			items = same.slice(0, nSame).concat(near.slice(0, nNear));
		}
		if (!items.length) take(apiItems, items, REC_TARGET);
		for (const handle of sources) {
			if (items.length >= REC_TARGET || !d.colourSection) break;
			const extra = await fetchCards(handle, []);
			take(chosen.length ? ranked(extra, harmony, matches) : extra, items, REC_TARGET);
		}
		if (items.length < 2) return null;

		const grid = document.createElement('div');
		grid.className = 'tp-rec__grid';
		grid.setAttribute('data-tp-rec-grid', '');
		grid.dataset.count = items.length;
		items.forEach((el) => grid.appendChild(el.ownerDocument === document ? el : document.importNode(el, true)));
		if (nSame || nNear) {
			const title = sec.querySelector('[data-tp-rec-title]');
			if (title) {
				if (!nNear) title.textContent = T('product.rec_same_colour', 'Tot în {colours}').replace('{colours}', colourList(chosen));
				else if (nSame) title.textContent = T('product.rec_colour_and_matching', 'În {colours} și culori asortate').replace('{colours}', lower(chosen).join(', '));
				else title.textContent = T('product.rec_matches', 'Se asortează cu {colours}').replace('{colours}', colourList(chosen));
			}
			const more = sec.querySelector('.tp-rec__more');
			if (more) more.hidden = true;
		}
		return grid;
	}

	// Rail with arrows (desktop/tablet; on phones the rail is swiped).
	function railify(sec, grid) {
		if (grid.children.length <= 4) return;
		grid.classList.add('tp-rec__grid--rail');
		const head = sec.querySelector('.tp-rec__head');
		if (!head || head.querySelector('.tp-rec__nav')) return;
		const nav = document.createElement('div');
		nav.className = 'tp-rec__nav';
		nav.innerHTML = '<button type="button" class="tp-rec__arrow" data-dir="-1" aria-label="' + T('product.prev_products', 'Produsele anterioare') + '">‹</button>'
			+ '<button type="button" class="tp-rec__arrow" data-dir="1" aria-label="' + T('product.next_products', 'Produsele următoare') + '">›</button>';
		head.appendChild(nav);
		const [prev, next] = nav.children;
		const sync = () => {
			prev.disabled = grid.scrollLeft <= 2;
			next.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
		};
		nav.addEventListener('click', (e) => {
			const b = e.target.closest('[data-dir]');
			if (b) grid.scrollBy({ left: Number(b.dataset.dir) * grid.clientWidth * 0.9, behavior: 'smooth' });
		});
		grid.addEventListener('scroll', sync, { passive: true });
		window.addEventListener('resize', sync);
		sync();
	}

	function initRecommendations() {
		document.querySelectorAll('[data-tp-rec]').forEach((sec) => {
			const mount = sec.querySelector('[data-tp-rec-mount]');
			const fallback = sec.querySelector('[data-tp-rec-fallback]');
			const fallbackItems = () => {
				const grid = fallback && fallback.content.querySelector('.tp-rec__grid');
				return grid ? Array.from(grid.children).map((el) => el.cloneNode(true)) : [];
			};
			const load = (intent) => fetch(sec.dataset.url + '&intent=' + intent)
				.then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
				.then((html) => {
					const doc = new DOMParser().parseFromString(html, 'text/html');
					const grid = doc.querySelector('[data-tp-rec-grid]');
					return grid ? Array.from(grid.children) : [];
				})
				.catch(() => []);
			const show = (grid) => {
				mount.replaceChildren(grid);
				sec.hidden = false;
				railify(sec, grid);
			};
			const run = async () => {
				let api = await load(sec.dataset.intent);
				if (api.length < 2) api = [];
				api = api.concat(fallbackItems());
				let grid = null;
				try { grid = await loadRail(sec, api); } catch (e) {}
				if (grid) return show(grid);
				if (api.length) {
					const g = document.createElement('div');
					g.className = 'tp-rec__grid';
					api.forEach((el) => g.appendChild(document.importNode(el, true)));
					return show(g);
				}
				sec.hidden = true;
			};
			// Load once the page is idle (below the fold, so it never competes with the gallery).
			if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 2000 });
			else setTimeout(run, 300);
		});
	}

	function init() {
		document.querySelectorAll('[data-tp]').forEach((root) => {
			const gallery = initGallery(root);
			initLightbox(root);
			initForm(root, gallery);
		});
		initRecommendations();
	}

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
	else init();
})();
